import { render, staticRenderFns } from "./Karkas.vue?vue&type=template&id=34873794&"
import script from "./Karkas.vue?vue&type=script&lang=js&"
export * from "./Karkas.vue?vue&type=script&lang=js&"
import style0 from "./Karkas.vue?vue&type=style&index=0&id=34873794&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports